import { render, staticRenderFns } from "./rfp-response-comparison.vue?vue&type=template&id=82812036&scoped=true&"
import script from "./rfp-response-comparison.vue?vue&type=script&lang=js&"
export * from "./rfp-response-comparison.vue?vue&type=script&lang=js&"
import style0 from "./rfp-response-comparison.vue?vue&type=style&index=0&id=82812036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82812036",
  null
  
)

export default component.exports